import memoize from 'memoize-one';

export const getUserSubmissionSectionResults = memoize((userId, submissions) =>
  Object.values(submissions).reduce((mem, sub) => {
    const sid = sub.practice_mode_section_id;
    if (sid && sub.user_id === userId) {
      mem[sid] ||= { attempted: 0, total_score: 0, total_total: 0, total_points: 0 };
      mem[sid].attempted += 1;
      const subRes = getLastSubmissionAttempt(sub)?.result;
      if (subRes) {
        mem[sid].total_score += subRes.total ? subRes.points / subRes.total : 0;
        mem[sid].total_total += subRes.total || 0;
        mem[sid].total_points += subRes.points || 0;
      }
    }
    return mem;
  }, {}),
);

function getLastSubmissionAttempt(sub) {
  if (!sub.submission_attempts) return;
  const lastKey = Object.keys(sub.submission_attempts)
    .map(k => parseInt(k))
    .sort((a, b) => a - b)
    .at(-1);
  return sub.submission_attempts[lastKey];
}
